import {useTranslation} from "react-i18next";
function SearchInputComponent({searchTerm, handleSearch}) {
    const {t} = useTranslation();
    return (
        <div>
            <input
                type={"text"}
                onChange={handleSearch}
                value={searchTerm}
                placeholder={t('action.search')}
                className="mt-1 w-full block rounded-md border-gray-500 py-1 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
        </div>
    );
}

export default SearchInputComponent;